import script from "./FormCheckbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormCheckbox.vue?vue&type=script&setup=true&lang=ts"

import "./FormCheckbox.vue?vue&type=style&index=0&id=21df8732&lang=scss"

const __exports__ = script;

export default __exports__